import { Component, Input, OnChanges, OnDestroy, OnInit, ViewContainerRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { ChangeEvent } from 'angular2-virtual-scroll';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Bank } from '../../models/sendmoney/bankAccount';
import {
  AdditionalInfo,
  AgentDetails,
  BeneficiaryDetails,
  CardDetails,
  locationType,
  PaymentDetails,
  PickupType,
  SendMoneyDetail,
  SendMoneySteps,
  StoreDetails,
  SummaryDetails
} from '../../models/sendmoney/sendmoney';
import { UserGioLocation } from '../../models/user/usergioLocation';
// Modal-Popup
import { AgentDetailModalComponent } from '../../sendMoney/_modalpopup/agent-popup/agent-popup.component';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { StatelistComponent } from '../../sharedcomponents/_common/countrylist/statelist.component';
import { CitylistComponent } from '../../sharedcomponents/_common/countrylist/citylist.component';
import * as _ from 'lodash';
export interface ListItem {
  PayingAgentRating?: string;
}
@Component({
  selector: 'app-pickup-center',
  templateUrl: './pickup-center.component.html',
  styleUrls: ['./pickup-center.component.css'],
  providers: [AlertService, Modal, CountryService]
})
export class PickupCenterComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  items: ListItem[];

  // buffer: any[] = [];
  agentItems: any = [];
  bankItems: any = [];
  loading: boolean;
  isAgentData: boolean = true;
  sendMoneyDetail: SendMoneyDetail;
  agentDetails;
  modeldata: any = {};
  payerCollection: any = [];
  bankCollection: any = [];
  countrycollection: any;
  stateCollection: any;
  cityCollection: any;
  BranchDetails: any;
  countryName: string;
  agentImgData: string;
  public filterByCollection = [];
  public sortByCollection = [];
  public fixed: boolean = false;
  PageFlow: any = {};
  pickupType: any;
  isFirstLoad: boolean = true;
  numRecordSearch: number = 1000;
  userGioLocation: UserGioLocation;
  OccupationNameObj: any;
  finalOccuppeancyresults = [];
  //taxes: any;
  //taxesDetail: any;

  // Declare height and width variables
  // scrHeight: any;
  // scrWidth: any;

  // @HostListener('window:resize', ['$event'])
  // getScreenSize(event?) {
  //   this.scrHeight = window.innerHeight;
  //   this.scrWidth = window.innerWidth;
  //   //console.log(this.scrHeight, this.scrWidth);
  // }

  // @HostListener('window:scroll', ['$event'])
  // onWindowScroll($event) {
  //     let number = window.pageYOffset || document.documentElement.scrollTop || window.scrollY || 0;
  //     this.fixed = number >= 80
  // }

  constructor(
    private router: Router,
    private modal: Modal,
    private alertService: AlertService,
    private countryserv: CountryService,
    private sendMoneyService: SendMoneyService,
    public utilityServ: utilityService,
    private geoloc: geolocation,
    private vcRef: ViewContainerRef,
    public translate: TranslateService
  ) {
    //this.getScreenSize();
    this.pickupType = PickupType;
    // this.sendMoneyService.getPageFlow().subscribe(data => {
    //   this.PageFlow = data;
    // });
    this.PageFlow.Value = sessionStorage.PageFlow;
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });
    if (this.PageFlow.Value == 'repeatorder') {
      this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
        this.sendMoneyDetail = data;
      });
    } else {
      this.sendMoneyDetail.beneficiaryDetails = new BeneficiaryDetails();
      this.sendMoneyDetail.summaryDetails = new SummaryDetails();
      this.sendMoneyDetail.storeDetails = new StoreDetails();
      this.sendMoneyDetail.cardDetails = new CardDetails();
      this.sendMoneyDetail.paymentDetails = new PaymentDetails();
      this.sendMoneyDetail.additionalInfo = new AdditionalInfo();
    }

    this.agentDetails = new AgentDetails();
    this.populateFilterByandSortBy();
  }

  ngOnInit() { }
  InitPage() {
    this.agentDetails.DeliveryMethod = this.sendMoneyDetail.pickupTypeDetails.pickupType;
    this.agentDetails.CountrySupportedCurrencyCodesTo = this.sendMoneyDetail.pickupTypeDetails.currencies;
    this.agentDetails.CountryTo = this.sendMoneyDetail.pickupTypeDetails.countryPreference;
    this.modeldata.State = '';
    this.countrycollection = this.countryserv.getCountryListFromLocaleEx();
    this.populateState();
    // this.agentDetails.StateTo = this.stateCollection[0].StateCode;
    this.agentDetails.StateTo = '';
    this.ddlStateOnChange(this.sendMoneyDetail.agentDetails.StateTo);
    if (this.sendMoneyDetail.agentDetails.StateTo != '' && this.sendMoneyDetail.agentDetails.CityTo != '') {
      this.agentDetails.StateTo = this.sendMoneyDetail.agentDetails.StateTo;
      this.ddlStateOnChange(this.sendMoneyDetail.agentDetails.StateTo);
      this.agentDetails.CityTo = this.sendMoneyDetail.agentDetails.CityTo;
      this.sendMoneyDetail.agentDetails.ImageData = '';
      this.sendMoneyDetail.agentDetails.AgentName = '';
      this.searchClick();
    }
    if (this.agentDetails.StateTo == '') {
      document.getElementById('ddlState').click();
    }

    // this.searchForPayer();
  }
  populateFilterByandSortBy() {
    this.utilityServ.busy = this.sendMoneyService.getFilterBySortByData().subscribe(data => {
      data.FilterBy = _.sortBy(data.FilterBy, 'FilterByID');
      data.SortBy = _.sortBy(data.SortBy, 'SortByID');
      this.filterByCollection = data.FilterBy;
      this.sortByCollection = data.SortBy;
      this.agentDetails.SortBy = data.SortBy[0].SortByID;
      this.agentDetails.FilterBy = data.FilterBy[0].FilterByID;

      this.payerCollection = [];
      this.bankCollection = [];
      this.agentDetails.RecordCount = this.numRecordSearch;

      this.InitPage();
      // if (this.scrHeight > 800 && this.scrHeight < 1000) {
      //   this.agentDetails.RecordCount = 20;
      //   this.numRecordSearch = 20;
      // } else if (this.scrHeight > 1000) {
      //   this.agentDetails.RecordCount = 40;
      //   this.numRecordSearch = 40;
      // }

      this.isAgentData = true;
    });
  }

  populateState() {
    const countryCode = this.sendMoneyDetail.pickupTypeDetails.countryPreference;
    const coll = this.countrycollection.filter(function (country) {
      return country.CountryCode === countryCode;
    });
    if (coll.length > 0) {
      this.agentDetails.CountryTo = coll[0].CountryCode;
      this.stateCollection = coll[0].states;
      this.countryName = coll[0].Name;
    }

    // .filter(function(lang) {
    //   return (
    //     lang.Language.toUpperCase() === sessionStorage.langCode.toUpperCase()
    //   );
    // })[0].Name;
  }

  ddlStateOnChange(stateCode) {
    if (stateCode == '') {
      this.cityCollection = [];
      return;
    }
    this.cityCollection = this.stateCollection.filter(function (state) {
      return state.StateCode === stateCode;
    })[0].Cities;
    // if (this.cityCollection != null) {
    //   this.agentDetails.CityTo = this.cityCollection[0];
    // }
    this.agentDetails.CityTo = '';
  }

  fetchMore(event: ChangeEvent) {
    if (this.isAgentData == false) return;
    if (event.end !== this.payerCollection.length) return;
    this.loading = true;
    this.fetchNextChunk(this.payerCollection.length, this.numRecordSearch).then(
      chunk => {
        this.payerCollection = this.payerCollection.concat(chunk);
        this.loading = false;
      },
      () => (this.loading = false)
    );
  }

  fetchNextChunk(skip: number, limit: number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.searchForPayer();
    });
  }

  fetchMoreBank(event: ChangeEvent) {
    if (this.isAgentData == false) return;
    if (event.end !== this.bankCollection.length) return;
    this.loading = true;
    this.fetchNextChunkBank(this.bankCollection.length, this.numRecordSearch).then(
      chunk => {
        this.bankCollection = this.bankCollection.concat(chunk);
        this.loading = false;
      },
      () => (this.loading = false)
    );
  }

  fetchNextChunkBank(skip: number, limit: number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.searchForPayer();
    });
  }
  searchClick() {
    this.agentDetails.Index = 0;
    this.isAgentData = true;
    this.payerCollection = [];
    this.bankCollection = [];
    this.searchForPayer();
  }
  searchForPayer() {
    let _self = this;
    this.agentDetails.FilterByText = '';
    this.agentDetails.SortByText = '';
    this.agentDetails.EndUserLatitude = this.userGioLocation.latitude;
    this.agentDetails.EndUserLongitude = this.userGioLocation.longitude;
    let FilterByText = this.filterByCollection.filter(function (item) {
      return item.FilterByID === _self.agentDetails.FilterBy;
    });
    if (FilterByText.length > 0) {
      this.agentDetails.FilterByText = FilterByText[0].FilterByName;
    }

    let SortByText = this.sortByCollection.filter(function (item) {
      return item.SortByID === _self.agentDetails.SortBy;
    });
    if (SortByText.length > 0) {
      this.agentDetails.SortByText = SortByText[0].SortByName;
    }

    this.agentDetails.ProgramId = this.sendMoneyDetail.sendMoneyProgramDetail.ProgramId;
    this.agentDetails.srcAmount = this.sendMoneyDetail.sendMoneyProgramDetail.srcAmount;
    this.geoloc.getGioLocation().subscribe(data => {
      this.userGioLocation = data;
      //this.geoloc.setserGioLocation(data);
      this.utilityServ.busy = this.sendMoneyService.searchPayerDetails(this.agentDetails, this.userGioLocation).subscribe(
        data => {
          //console.log("LA data de bank", data)
          this.agentDetails.Index = this.agentDetails.Index + this.numRecordSearch;
          // this.agentDetails.Index = this.agentDetails.Index + 1;
          if (data.StatusCode == 10000) {
            this.isFirstLoad = false;
            // this.payerCollection = [];
            // this.bankCollection = [];
            if (
              this.agentDetails.DeliveryMethod == PickupType.officePickup ||
              this.agentDetails.DeliveryMethod == PickupType.homeDelivery ||
              this.agentDetails.DeliveryMethod == PickupType.atmDeposit
            ) {
              //  this.payerCollection = data.AgentList;
              if (data.AgentList.length == 0 || data.AgentList.length < this.numRecordSearch) {
                this.isAgentData = false;
              }



              data.AgentList.forEach(element => {
                this.utilityServ.busy = this.sendMoneyService.getPayerLogo(element).subscribe(
                  data => {
                    if (data.HasDefaultImage == true) {
                      this.agentImgData = '';
                    } else {
                      this.agentImgData = 'data:image/gif;base64,' + data.PayingAgentImageData;
                    }

                    element.imageData = this.agentImgData;
                  },
                  error => { }
                );
              });
              this.payerCollection = this.payerCollection.concat(data.AgentList);
            } else if (this.agentDetails.DeliveryMethod == PickupType.bankDeposit) {
              if (data.Banks.length == 0 || data.Banks.length < this.numRecordSearch) { this.isAgentData = false; }
              //this.bankCollection = data.Banks;
              data.Banks.forEach(element => {
                this.utilityServ.busy = this.sendMoneyService.getBankLogo(element).subscribe(
                  data => {
                    if (data.HasDefaultImage == true) {
                      this.agentImgData = '';
                    } else {
                      this.agentImgData = 'data:image/gif;base64,' + data.BankImageData;
                    }
                    element.imageData = this.agentImgData;
                  },
                  error => { }
                );
              });
              this.bankCollection = this.bankCollection.concat(data.Banks);
            }
          } else {
            this.alertService.error(data.StatusMessage);
          }
        },
        error => { }
      );
    });
  }

  getRatingClass(rating) {
    let classVal;
    switch (parseInt(rating, 0)) {
      case 0: {
        classVal = 'rating-0';
        break;
      }
      case 1: {
        classVal = 'rating-1';
        break;
      }
      case 2: {
        classVal = 'rating-2';
        break;
      }
      case 3: {
        classVal = 'rating-3';
        break;
      }
      case 4: {
        classVal = 'rating-4';
        break;
      }
      case 5: {
        classVal = 'rating-5';
        break;
      }
    }
    return classVal;
  }

  payerRowClick(pc) {
    this.agentDetails.PayingAgentId = pc.PayingAgentId;
    this.agentDetails.CurrencyTo = pc.Currency;
    this.agentDetails.LocationId = pc.LocationId;
    //console.log("Es el 2");
    this.utilityServ.busy = this.sendMoneyService.getBranchDetails(this.agentDetails).subscribe(
      data => {
        if (data.StatusCode == 10000) {
          this.BranchDetails = data;
          this.sendMoneyDetail.pickupCenterDetails = pc;
          this.agentDetails.ImageData = pc.imageData;
          this.sendMoneyDetail.pickupCenterDetails.imgData = pc.imageData;
          this.agentDetails.AgentName = pc.PayingAgentName;
          this.sendMoneyDetail.paymentDetails.destCurrCode = pc.Currency;
          // commented if it comes from repeat order the src amount has some value
          // this.sendMoneyDetail.paymentDetails.srcAmount = this.agentDetails.srcAmount;
          this.sendMoneyDetail.agentDetails = this.agentDetails;

          let self = this;
          this.sendMoneyDetail.branchDetails = this.BranchDetails.Branches.filter(function (branch) {
            return branch.LocationId == self.agentDetails.LocationId;
          })[0];

          this.sendMoneyDetail.paymentDetails.processingFee = parseFloat(this.sendMoneyDetail.branchDetails.CustomerFee.toString());
          //this.sendMoneyDetail.paymentDetails.TaxAmount = this.sendMoneyDetail.branchDetails.TaxAmount;
          //this.sendMoneyDetail.paymentDetails.TaxDetails = this.sendMoneyDetail.branchDetails.TaxDetails;
          this.sendMoneyDetail.paymentDetails.exchangeRate = this.sendMoneyDetail.branchDetails.RateCustomer.toString();
          this.sendMoneyDetail.paymentDetails.totalAmount = Number(this.sendMoneyDetail.paymentDetails.srcAmount) + Number(this.sendMoneyDetail.paymentDetails.processingFee);
          this.sendMoneyDetail.paymentDetails.minimumDenomination=Number(this.sendMoneyDetail.branchDetails.MinimumDenomination);
          this.sendMoneyDetail.branches = this.BranchDetails.Branches;
          this.sendMoneyDetail.paymentDetails.TaxAmount = 0;
          this.sendMoneyDetail.paymentDetails.TaxDetails = null;
          this.sendMoneyDetail.branchDetails.TaxAmount = 0;
          this.sendMoneyDetail.branchDetails.TaxDetails = null;
          //console.log("a ver aqui", this.sendMoneyDetail)
          this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);

          if (pc.LocationType.LocationTypeId === locationType.collectAnyBranch || pc.LocationType.LocationTypeId === locationType.singleLocation) {
            const modalData = this.agentDetails;
            // this.modal.open(AgentDetailModalComponent, overlayConfigFactory({ modalData }, BSModalContext));
            this.modal.overlay.defaultViewContainer = this.vcRef;
            return this.modal.open(AgentDetailModalComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
              obj.onDestroy.subscribe(data => {
                if (modalData.next === 'agentdetails') {
                  self.router.navigate(['/agentdetails']);
                } else if (modalData.next === 'continue') {
                  if (self.PageFlow.Value == 'repeatorder') {
                    if (sessionStorage.RepeatOrderFlow != undefined && sessionStorage.RepeatOrderFlow != '') {
                      self.router.navigate(['/' + sessionStorage.RepeatOrderFlow]);
                    } else {
                      self.router.navigate(['/repeatorderlist']);
                    }
                  } else {
                    self.sendMoneyService.setModalPopup(SendMoneySteps.Beneficiary);
                  }
                }
              });
            });
          } else if (pc.LocationType.LocationTypeId === locationType.multiLocation) {
            const modalData = this.agentDetails;
            this.router.navigate(['/branches']);
            return; 
          }
        } else {
          // alert(data.StatusMessage);
        }
      },
      error => { }
    );
  }

  bankRowClick(pc) {
    let bankobj: Bank = pc;
    this.sendMoneyDetail.bankDetails = bankobj;
    // commented if it comes from repeat order the src amount has some value
    // this.sendMoneyDetail.paymentDetails.srcAmount = this.agentDetails.srcAmount;
    this.sendMoneyDetail.agentDetails = this.agentDetails;
    this.sendMoneyDetail.agentDetails.ImageData = bankobj.imageData;
    this.sendMoneyDetail.pickupCenterDetails.imgData = bankobj.imageData;
    this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
    let self = this;
    const modalData: any = {};
    this.modal.overlay.defaultViewContainer = this.vcRef;
    return this.modal.open(AgentDetailModalComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
      obj.onDestroy.subscribe(data => {
        if (modalData.next === 'agentdetails') {
          self.router.navigate(['/bankdetails']);
        } else if (modalData.next === 'continue') {
          self.router.navigate(['/addaccountdetail']);
        }
      });
    });
  }

  setOccupation() {
    this.countrycollection = this.countryserv.getCountryListFromLocaleEx();
    let resultSet = this.countrycollection.filter(item => item.CountryCode == 'MX')[0].states;
    this.OccupationNameObj = resultSet;
  }

  search(event) {
    let resultSet = this.countrycollection.filter(item => item.CountryCode == 'MX')[0].states;
    this.finalOccuppeancyresults = resultSet.filter(item => {
      return item.StateAlias.find(state => state.toLowerCase().indexOf(event.query.toLocaleLowerCase()) > -1);
    });
  }
  captureId(event: any) {
    this.modeldata.State = event.StateName;
  }

  openStateBox() {
    let self = this;
    let modalData: any = {};
    modalData.Title = this.translate.instant('CountryPreference_titleLogin').toString();
    modalData.Message = this.translate.instant('CountryPreference_descLogin').toString(); //'Please select your Country of preference from the list below:';
    modalData.CountryCode = this.agentDetails.CountryTo;
    return this.modal.open(StatelistComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
      obj.onDestroy.subscribe(data => {
        self.modeldata.State = '';
        if (modalData.next.StateCode == undefined) {
        } else {
          self.agentDetails.StateTo = modalData.next.StateCode;
          self.modeldata.State = modalData.next.StateName;
          self.ddlStateOnChange(modalData.next.StateCode);
          self.openCityBox();
        }
      });
    });
  }

  openCityBox() {
    let self = this;
    let modalData: any = {};
    modalData.Title = this.translate.instant('CountryPreference_titleLogin').toString();
    modalData.Message = this.translate.instant('CountryPreference_descLogin').toString(); //'Please select your Country of preference from the list below:';
    modalData.CountryCode = this.agentDetails.CountryTo;
    modalData.StateCode = this.agentDetails.StateTo;
    return this.modal.open(CitylistComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
      obj.onDestroy.subscribe(data => {
        if (modalData.next.City == undefined) {
        } else {
          self.agentDetails.CityTo = modalData.next.City;
          self.searchClick();
        }
      });
    });
  }

  ngOnDestroy() { }
  ngOnChanges() { }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/pickup-center/pickup-center.component.ts